import React, { useState, useEffect } from 'react';
import { collection, addDoc, getDocs, query, where } from 'firebase/firestore';
import { db } from '../firebase'; 
import { useAuth } from '../contexts/authContext'; 

const CreateGroup = () => {
  const [orgId, setOrgId] = useState('');
  const [groupName, setGroupName] = useState('');
  const [userEmail, setUserEmail] = useState(''); 
  const [organizations, setOrganizations] = useState([]);
  const { currentUser } = useAuth();

  useEffect(() => {
    const fetchOrgs = async () => {
      if (!currentUser) return;

      const orgsQuery = currentUser.role === 'super-admin'
        ? collection(db, 'organizations')
        : query(collection(db, 'organizations'), where('admins', 'array-contains', currentUser.email));
      
      const orgSnapshot = await getDocs(orgsQuery);
      const orgsData = orgSnapshot.docs.map(doc => ({
        id: doc.id, // Custom document ID
        name: doc.data().name
      }));
      setOrganizations(orgsData);
    };

    fetchOrgs();
  }, [currentUser]);

  const handleCreateGroup = async (e) => {
    e.preventDefault();

    try {
      const groupRef = await addDoc(collection(db, 'groups'), {
        orgId: orgId || null, // Optional organization association
        name: groupName,
        users: [userEmail],
        createdBy: currentUser.uid,
      });
      console.log('Group created with ID:', groupRef.id);
      setGroupName('');
      setUserEmail('');
      alert(`Group ${groupName} created successfully!`);
    } catch (error) {
      console.error('Error creating group:', error);
      alert('Error creating group.');
    }
  };

  return (
    <div>
      <div className="container mx-auto mt-8 p-4 bg-white shadow-md rounded-lg">
        <h2 className="text-2xl font-bold mb-6">Create New Group</h2>
        <form onSubmit={handleCreateGroup} className="space-y-4">
          <div>
            <label htmlFor="orgId" className="block font-medium text-gray-700">Organization (Optional)</label>
            <select
              id="orgId"
              value={orgId}
              onChange={(e) => setOrgId(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded-lg"
            >
              <option value="">Select an organization (optional)</option>
              {organizations.map((org) => (
                <option key={org.id} value={org.id}>{org.name}</option>
              ))}
            </select>
          </div>
          <div>
            <label htmlFor="groupName" className="block font-medium text-gray-700">Group Name</label>
            <input
              type="text"
              id="groupName"
              value={groupName}
              onChange={(e) => setGroupName(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded-lg"
              required
            />
          </div>
          <div>
            <label htmlFor="userEmail" className="block font-medium text-gray-700">User Email</label>
            <input
              type="email"
              id="userEmail"
              value={userEmail}
              onChange={(e) => setUserEmail(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded-lg"
              placeholder="Email of user to add to group"
            />
          </div>
          <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700">
            Create Group
          </button>
        </form>
      </div>
    </div>
  );
};

export default CreateGroup;
